"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Logger_data, _Logger_options;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const env_1 = __importDefault(require("../../utils/env"));
class Logger {
    constructor(data = {}, options = {}) {
        _Logger_data.set(this, void 0);
        _Logger_options.set(this, void 0);
        __classPrivateFieldSet(this, _Logger_data, data, "f");
        __classPrivateFieldSet(this, _Logger_options, options, "f");
    }
    static write(message, data) {
        const method = data.level === 'error'
            ? 'error'
            : data.level === 'warning'
                ? 'warn'
                : 'log';
        if ((0, env_1.default)('NODE_ENV', 'development') === 'production') {
            console[method](JSON.stringify({ log: message, data }));
        }
        else {
            console[method](message, JSON.stringify(data, null, data.level === 'error' ? 2 : 0));
        }
    }
    static subscribe(level, callback) {
        const subscriptions = Logger.subscriptions.get(level) || [];
        Logger.subscriptions.set(level, [...subscriptions, callback]);
    }
    static unsubscribe(level, callback) {
        const subscriptions = Logger.subscriptions.get(level) || [];
        Logger.subscriptions.set(level, subscriptions.filter((subscription) => subscription !== callback));
    }
    static broadcast(message, data) {
        queueMicrotask(() => {
            const subscriptions = Logger.subscriptions.get(data.level);
            if (subscriptions && subscriptions.length > 0) {
                return Promise.all(subscriptions.map((subscription) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        return Promise.resolve(subscription(message, data));
                    }
                    catch (err) {
                        Logger.write('error broadcasting logs: ' + err.message, {
                            level: 'error',
                            message,
                            data,
                        });
                    }
                })));
            }
        });
    }
    extend(data = {}, options = {}) {
        return new Logger(Object.assign(Object.assign({}, __classPrivateFieldGet(this, _Logger_data, "f")), data), Object.assign(Object.assign({}, __classPrivateFieldGet(this, _Logger_options, "f")), options));
    }
    subscribe(level, callback) {
        Logger.subscribe(level, callback);
        return this;
    }
    unsubscribe(level, callback) {
        Logger.unsubscribe(level, callback);
        return this;
    }
    write(message, data) {
        if (!__classPrivateFieldGet(this, _Logger_options, "f").disabled) {
            const extended = Object.assign(Object.assign({}, data), __classPrivateFieldGet(this, _Logger_data, "f"));
            Logger.write(message, extended);
            Logger.broadcast(message, extended);
        }
    }
    log(message, data = {}) {
        return this.write(message, { level: 'info', data });
    }
    warning(message, data = {}) {
        return this.write(message, { level: 'warning', data });
    }
    error(message, data = {}) {
        if (data instanceof Error) {
            data = Object.assign(Object.assign({}, data), { message: data.message, stack: data.stack });
        }
        return this.write(message, { level: 'error', data });
    }
}
exports.Logger = Logger;
_Logger_data = new WeakMap(), _Logger_options = new WeakMap();
Logger.subscriptions = new Map();
exports.default = new Logger();
